import { useEffect } from 'react'

export const useCloseOnChanges = (open, onClose, deps) => {
  useEffect(() => {
    if (open) {
      onClose()
    }
  }, deps) // eslint-disable-line react-hooks/exhaustive-deps
}
